import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { RequireSuperAdmin } from './RequireSuperAdmin';
import LoginPage from './Login/LoginPage';
import DashboardPage from './Dashboard/DashboardPage';
import KnownIpsPage from './KnownIps/KnownIpsPage';
import CompaniesListPage from './Companies/CompaniesListPage';
import CreateCompanyPage from './Companies/CreateCompanyPage';
import CompanyDetailPage from './Companies/CompanyDetailPage';
import AuditLogPage from './AuditLog/AuditLogPage';

/**
 * Top-level switch for all /mika/ops/* routes.
 *
 * Mounted from App.tsx via <Route path="/mika/ops" component={SuperAdminRoutes} />.
 * Every authenticated sub-route goes through <RequireSuperAdmin>, which redirects to
 * /mika/ops/login when the sa_access_token is absent.
 */
const SuperAdminRoutes: React.FC = () => {
    return (
        <Switch>
            <Route exact path="/mika/ops/login" component={LoginPage} />

            <RequireSuperAdmin exact path="/mika/ops" component={DashboardPage} />
            <RequireSuperAdmin exact path="/mika/ops/known-ips" component={KnownIpsPage} />

            {/* Companies lifecycle. /new MUST come before /:id or react-router-dom v5 will
                match "new" as an id parameter. */}
            <RequireSuperAdmin exact path="/mika/ops/companies" component={CompaniesListPage} />
            <RequireSuperAdmin exact path="/mika/ops/companies/new" component={CreateCompanyPage} />
            <RequireSuperAdmin exact path="/mika/ops/companies/:id" component={CompanyDetailPage} />

            <RequireSuperAdmin exact path="/mika/ops/audit-log" component={AuditLogPage} />

            <Redirect to="/mika/ops" />
        </Switch>
    );
};

export default SuperAdminRoutes;
